import type { SchoolRecord } from '@shared/schools/schoolData.js';

const SECTION_NATURE_OVERRIDES: Record<string, string> = {
  'anglo-chinese-school-independent':
    "Boys' school (Years 1-4); co-ed (Years 5-6 / IB)",
  'hwa-chong-institution':
    "Boys' school (High School / Years 1-4); co-ed (College / JC)",
  'raffles-institution': "Boys' school (Years 1-4); co-ed (Years 5-6 / JC)",
  'st-josephs-institution':
    "Boys' school (Secondary / Years 1-4); co-ed (Years 5-6 / IB)",
};

function formatSchoolFactCode(value: string): string {
  return value
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getSchoolNatureText(school: SchoolRecord): string {
  return (
    SECTION_NATURE_OVERRIDES[school.slug] ??
    formatSchoolFactCode(school.natureCode)
  );
}
